export function getBackendBaseUrl() {
  // Backend is proxied by Nginx under `/api` (relative to the current origin).
  // We intentionally avoid hardcoding domains so the app works in production.
  return '';
}

